import { Box, Card, CircularProgress, Grid, Typography } from '@mui/material'
import React from 'react'
import MainContainer from 'theme/MainConatiner'
import "./style.css";
import NoItemsCreated from 'components/NoItemsCreated/NoItemsCreated';
import HeaderTilteBar from 'components/TitleBar/HeaderTilteBar';
import NoSearchFound from 'components/NoSearchFound/NoSearchFound';
import NoTimeSlotImg from "assests/no-time-slot.svg";
import CommonDataGrid from 'components/TableListing/CommonTable';


const TimeSlotsContainer = ({
    columns,
    rows,
    totalCount,
    loading,
    paginationModel,
    setPaginationModel,
    error,
    handleAddBtn,
    handleCategoryBtn,
}) => {
    const isSearching = false;
    const hasData = !loading && rows.length > 0;
    const showNoItems = !loading && rows.length === 0 && !error;

    return (
        <MainContainer>
            <Card className='main-card-container' sx={{ padding: '0px !important' }}>
                <HeaderTilteBar
                    title={"Time Slots & Discounts"}
                    isSearch={false}
                    btnText={"Add New"}
                    btnIcon={true}
                    // onSearchChange={setSearchQuery}
                    // searchQuery={searchTxt}
                    handleAddBtn={handleAddBtn}
                    handleCategoryBtn={handleCategoryBtn}
                    secondBtnText={"Categories"}
                    isSecondBtn={true}
                    // padding={"16px 15px 8px 15px"}
                // handleBack={handleBack}
                />

                {showNoItems && (
                    <Box className='body-wrapper'>
                        {isSearching ? (
                            <NoSearchFound
                                title="No Collection Point matches your search"
                                subtitle={`Please try again with a different keyword to get result..`}
                            />
                        ) : (
                            <NoItemsCreated
                                title="No Time Slots Created Yet!."
                                // subtitle="Add your first food category to create your own menu."
                                img={NoTimeSlotImg}
                                width={"250px"}
                                height={"250px"}
                            />
                        )}
                    </Box>
                )}

                {!showNoItems && (
                    <Box>
                        <CommonDataGrid
                            columns={columns}
                            rows={rows}
                            rowCount={totalCount}
                            loading={loading}
                            paginationModel={paginationModel}
                            setPaginationModel={setPaginationModel}
                        />
                    </Box>
                )}
            </Card>
        </MainContainer>
    )
}

export default TimeSlotsContainer